import EventEmitter from "eventemitter3";

export const eventManager = new EventEmitter();
